import { useI18n, Trans } from '~/common/context';
import { Modal, Flex, Button, ButtonVariant } from '@wyz/ui';
import * as React from 'react';

type ResetPasswordModalProps = {
  children?: React.ReactNode;
  onConfirm: () => Promise<void> | void;
  onClose: () => void;
  onCancel?: () => Promise<void> | void;
  isLocked?: boolean;
  title?: string;
  confirmBtnText?: string;
  confirmVariant?: ButtonVariant;
};

function ResetPasswordModal(props: ResetPasswordModalProps) {
  const { t } = useI18n();
  const {
    onClose,
    onCancel,
    onConfirm,
    title = 'Confirmation',
    confirmBtnText,
    confirmVariant,
    isLocked,
  } = props;

  const handleOnConfirm = async () => {
    try {
      await onConfirm();
    } finally {
      onClose();
    }
  };
  const handleOnCancel = async () => {
    try {
      if (onCancel) {
        await onCancel();
      }
    } finally {
      onClose();
    }
  };
  return (
    <Modal.Container open={true} onClose={onClose}>
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <span>
          <Trans i18nKey='app.user.edit.reset_password.confirmation_message' />
        </span>
        <span>
          {isLocked && t('app.user.detail.unlock.confirmation_message')}
        </span>
      </Modal.Body>
      <Modal.Footer>
        <Flex className='w-100 space-x-4'>
          <Button
            id='cancel-modal'
            variant='secondary'
            className='mx-2'
            onClick={handleOnCancel}
            fullWidth
          >
            <Trans i18nKey='app.common.button.cancel' />
          </Button>
          <Button
            id='submit-modal-reset-password'
            variant={confirmVariant || 'primary'}
            type='submit'
            onClick={handleOnConfirm}
            fullWidth
          >
            {confirmBtnText || t('app.common.button.confirm')}
          </Button>
        </Flex>
      </Modal.Footer>
    </Modal.Container>
  );
}

export default ResetPasswordModal;
